// extracted by mini-css-extract-plugin
module.exports = {"add-gift-pack":"_1LXC_bb0Z0","tip-style":"_1L-FyV5xgq","form-style":"_1Smu6Yohds","input-style":"_131Sckb6AE"};